import { AddIcon, CheckIcon, CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  List,
  ListIcon,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import React, { FormEvent, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getAddAnswerData,
  setAnswers,
  setContent as setAnswerContent,
  setIsCorrect,
} from "redux/slices/addAnswerSlice";
import { getAddQuestionData, setContent } from "redux/slices/AddQuestionSlice";
import AddAnswer from "./AddAnswer";
//import { getAddQuestionData, setFiles, setName } from "redux/slices/AddQuestionSlice"

interface AddQuestionProps {
  id: number;
  setId: React.Dispatch<React.SetStateAction<number>>;
  submitHandler: (e: React.FormEvent) => void;
}
const AddQuestion: React.FC<AddQuestionProps> = ({
  submitHandler,
  id,
  setId,
}: AddQuestionProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useAppDispatch();
  const [add, setAdd] = useState(false);
  const { content } = useAppSelector(getAddQuestionData);
  const answers = useAppSelector(getAddAnswerData).answers;
  const answerData = useAppSelector(getAddAnswerData);
  let answerId = Math.floor(Math.random() * 10000);
  const addAnswerSubmitHandler = (e: FormEvent) => {
    e.preventDefault();
    dispatch(
      setAnswers([
        ...answers,
        {
          id: answerId,
          addedOn: new Date(),
          content: answerData.content,
          isCorrect: answerData.isCorrect === "1" ? true : false,
          lastModifiedOn: new Date(),
          questionId: id,
        },
      ])
    );
    console.log(answers);
    setAdd(false);
    dispatch(setAnswerContent(""));
    dispatch(setIsCorrect("2"));
  };

  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme={"brand"} onClick={onOpen}>
        Ajouter Question
      </Button>

      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <form action="">
          <ModalContent>
            <ModalHeader>Ajouter un Question</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl id="email">
                <FormLabel>Contenu</FormLabel>
                <Input
                  value={content}
                  onChange={(e) => dispatch(setContent(e.target.value))}
                  borderRadius={"full"}
                  type="text"
                />
              </FormControl>

              <FormControl id="email">
                <FormLabel>Réponses</FormLabel>
                <IconButton
                  icon={<AddIcon />}
                  aria-label={""}
                  onClick={() => setAdd(true)}
                />
                <List spacing={3}>
                  {answers &&
                    answers
                      .filter((item) => item.questionId === id)
                      .map((item) => (
                        <ListItem>
                          <ListIcon
                            as={item.isCorrect === true ? CheckIcon : CloseIcon}
                            color={item.isCorrect ? "green.300" : "red.400"}
                          />
                          {item.content}
                        </ListItem>
                      ))}
                </List>
                {add && (
                  <AddAnswer
                    questionId={id}
                    submitHandler={addAnswerSubmitHandler}
                    addOrUpdate={"ADD"}
                  />
                )}
              </FormControl>
              <Stack my={5} direction="row" spacing={"auto"}></Stack>
            </ModalBody>

            <ModalFooter>
              <Button
                type="button"
                onClick={(e) => {
                  submitHandler(e);
                  onClose();
                }}
                colorScheme="brand"
                mr={3}
              >
                Enregistrer
              </Button>
              <Button onClick={onClose}>Annuler</Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>
    </>
  );
};
export default AddQuestion;
